<template>
  <section class="container" >
    <div class="main">
        <div class="row">
            <div class="col-md-6 ">
              <div class="col-12 ">
                <div class="mainImage">
                    <input type="file" @change="previewFiles($event ,  productForm.index)" ref="inputImage" hidden>
                    <div v-if="!productForm.ImagesUrl[0]">
                      <i class="fas fa-plus icChangeImage " @click="$refs.inputImage.click()"></i>
                      <img src="@/assets/images/product.png">
                    </div>
                    <div v-else>
                      <i class="fas fa-edit icChangeImage " @click="$refs.inputImage.click() , productForm.index=0"></i>
                      <img :src="productForm.ImagesUrl[0]">
                    </div>
                </div>
              </div>
                <div class="subImage">
                    <div class="row">
                        <div v-for="(Image , index) in productForm.ImageCount" :key="index" class="col-3 imageItem">
                          <div><i class="fas fa-edit icChangeImage " @click="$refs.inputImage.click() , productForm.index=index" ></i><img :src="productForm.ImagesUrl[index]" ></div>
                        </div>
                        <div class="col-3 imageItem">
                          <i class="fas fa-plus icInsDel " @click="$refs.inputImage.click() , productForm.index=null"></i>
                          <i class="fas fa-trash-alt icInsDel" @click="popImages()"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 detail">
              <div v-if="productForm.btnDeleteProduct">
                <div class="form-group btnDeleteProduct">
                  <button class="btn btn-danger"  data-toggle="modal" data-target="#exampleModal">ลบรายการนี้</button>
                </div>
                <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                  aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">ลบรายการสินค้า</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <p><b>รหัสสินค้า : </b> {{productForm.productId}}</p>
                        <p><b>ชื่อสินค้า : </b> {{productForm.name}}</p>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-hgn-primary" data-dismiss="modal" @click="deleteProduct()" >ตกลง</button>
                        <button type="button" class="btn btn-hgn-back" data-dismiss="modal">ยกเลิก</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>ชื่อสินค้า : </label>
                  <input type="text" class="form-control" v-model="productForm.name" placeholder="ซื่อสินค้า"> 
              </div>
              <div class="row form-group">
                <div class="col-2" style="padding-top: 6px">ราคา</div>
                <div class="col-8"><input type="number" min="0" class="form-control" v-model="productForm.price" placeholder="ราคาต่อหน่วย (ถ้ามี)"></div>
                <div class="col-2" style="padding-top: 6px">.บาท</div>
              </div>
              <div class="row form-group">
                <div class="col-2" style="padding-top: 6px">ต่อหน่วย</div>
                <div class="col-10"><input type="text" class="form-control" v-model="productForm.unitType" placeholder="ต่อ (อัน,โหล,แพ็ค)"></div>
              </div>
              <div class="row form-group">
                <div class="col-12" style="padding-top: 6px">คุณสมบัติสินค้า</div>
                <div class="col-12">
                  <vue-editor v-model="productForm.detail" :editorToolbar="editorCustomconfig.detail"></vue-editor>
                </div>
              </div>   
              <div class="row form-group">
                <div class="col-4" style="padding-top: 6px">Link ใบเสนอราคา</div>
                <div class="col-8"><input type="text" class="form-control" v-model="productForm.quotationLink" placeholder="link google form"></div>
              </div>                     
            </div>
        </div>
        <div class="col-12 borderBottom"></div>
        <div class="row discription">
          <div class="col-12">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab"
                  aria-controls="nav-home" aria-selected="true">คุณสมบัติสินค้า</a>
              </div>
            </nav>
          </div>
          <div class="col-12">
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <vue-editor v-model="productForm.description" :editorToolbar="editorCustomconfig.description"></vue-editor>
              </div>
            </div>
          </div>
        </div>
        <div class="btnMenu">
          <button class="btn btn-hgn-primary" @click="manageProduct()">บันทึก</button>
          <button class="btn btn-hgn-back" @click="$router.push('/')">ยกเลิก</button>
        </div>
        <h2 class="ql-align-center">บริการล้างแอร์สำหรับหอพัก</h2><br><p>บริการล้างแอร์สำหรับหอพัก อพาร์ทเม้น ราคาถูก คุณภาพดีเยี่ยม ด้วยทีมช่างมืออาชีพ ประสบการ์ณมากกว่า 15 ปี พร้อมให้บริการพื้นที่กรุงเทพ สมุทรปราการ นนทบุรี</p><p><br></p><p><strong>ค่าบริการ :</strong><ul><li> 10-50 เครื่อง = 500/ตัว</li><li> 51-100 เครื่อง = 450/ตัว</li><li> 100+ เครื่อง = 430/ตัว</li></ul></p>

    </div>
  </section>
</template>
<script>
import axios from "axios"
import Toolbar from "../editorConfig.js"
export default {
  async created(){
    if(this.$route.params.productId){
      try {
        if(this.$user)
        this.product = await this.Parse.Cloud.run('MarketProduct_getProductById',{productId : this.$route.params.productId})
        if(this.product){
          this.productForm.productId = this.product.id
          this.productForm.name  = this.product.get('name')
          this.productForm.detail  = this.product.get('detail')
          this.productForm.description  = this.product.get('description')
          this.productForm.price  = this.product.get('price') || null
          this.productForm.unitType  = this.product.get('unitType') || null
          this.productForm.quotationLink  = this.product.get('quotationLink')
          this.productForm.number  = this.product.get('number')
          for(let image of this.product.get('images')){
            this.productForm.ImagesUrl.push(image._url)
          }
          this.productForm.ImageCount = this.product.get('images').length
          this.productForm.btnDeleteProduct = true;
        }
      } catch (err) {
        console.log(err)
      }
    }
  },
  data() {
    return {
      productForm: {
        productId:"",
        name: "",
        detail:"",
        description:"",
        price:"",
        unitType:"",
        ImageCount: 0,
        ImagesUrl:[],
        index:0,
        ImageBase64:[],
        quotationLink:"",
        number:"",
        btnDeleteProduct:false
      },
      editorCustomconfig: {
        detail:Toolbar.detail,
        description:Toolbar.description
      },
      login:{
        loginStatus:false,
        user:"",
        pass:""
      }
    }
  },
  methods: {
    async manageProduct() {
      try{
        this.productForm.ImageBase64 = await this.callImageBase64(this.productForm.ImagesUrl)
        let result = await this.Parse.Cloud.run('MarketProduct_manageProduct',{productForm : this.productForm , productId : this.$route.params.productId})
        if(result) this.$router.push('/')
      }catch(err){
        console.log(err)
      }
    },
    async deleteProduct(){
      try{
        let result = await this.Parse.Cloud.run('MarketProduct_deleteProduct',{productId : this.$route.params.productId})
        if(result) {
          this.$router.push('/')
          this.btnDeleteProduct = false
        }
      }catch(err){
        console.log(err)
      }
      
    },
    async previewFiles(event , index) {
        let base64 = await this.getImage(URL.createObjectURL(event.target.files[0]))
        let parseFile = new this.Parse.File("image.jpg", { base64: base64 });
        let file = await parseFile.save()
        console.log(file)
        console.log(JSON.stringify(file))
    //   if(index != null){
    //     if(event.target.files[0]){
    //       this.productForm.ImagesUrl[index] = URL.createObjectURL(event.target.files[0])
    //       this.productForm.ImageCount = 0 
    //       this.productForm.ImageCount = this.productForm.ImagesUrl.length
    //     }
    //   }else{
    //     if(event.target.files[0]){
    //       this.productForm.ImageCount += 1
    //       this.productForm.ImagesUrl.push(URL.createObjectURL(event.target.files[0]))
    //     }
    //   }
    //   this.$refs.inputImage.value = ""
    },
    async popImages() {
      this.productForm.ImagesUrl.pop()
      this.productForm.ImageCount = 0 
      this.productForm.ImageCount = this.productForm.ImagesUrl.length
    },
    async getImage(url) {
      return await axios
        .get(url, {
          responseType: 'arraybuffer'
        })
        .then(response => new Buffer(response.data, 'binary').toString('base64'))
    },
    async callImageBase64(v){
      return new Promise(async (resolve , reject) =>{
        let base64 = []
        for(let x of v){
          base64.push(await this.getImage(x))
        }
        resolve(base64)
      })
    },
    onClickLogin(){
      if(this.login.user == this.$adminUser && this.login.pass == this.$adminPass){
        this.login.loginStatus = true;
      }else{
        alert("รหัสไม่ถูกต้อง")
      }
    }
  }
}
</script>
<style scoped>
.container{
  background-color: #ffffff;
  padding: 20px;
}
img{
    width: 100%;
    height: auto;
}
.mainImage{
    padding: 10px;
}
.icChangeImage{
  position: absolute;
  cursor: pointer;
  background-color: rgb(0, 0, 0,0.2);
  border-radius: 5px;
  color: #4b4b4b
}
.mainImage .icChangeImage{
  top: 43%;
  left: 43%;
  font-size:30px;
  padding: 20px;
}
.subImage .icChangeImage{
  top: 35%;
  left: 35%;
  font-size:15px;
  padding: 15px;
}
.subImage .icInsDel{
  cursor: pointer;
  background-color: rgb(0, 0, 0,0.2);
  border-radius: 5px;
  color: #4b4b4b;
  font-size:17px;
  padding: 15px;
  margin-right: 5px;
  margin-bottom: 5px;
}
.icChangeImage:hover , .icInsDel:hover{
  background-color: rgb(0, 0, 0,0.5);
}
.subImage{
  margin-top: 10px;
  margin-bottom: 20px;
}
.imageItem{
  margin-top: 10px;
  padding: 1%;
}
.btnDeleteProduct{
  text-align: right;
}
.detail{
  margin-top: 20px;
}
.price input{
  width: 150px;
  margin-top: 15px;
}
textarea{
  width: 100%;
  display: block;
  float: left;
}
.discription{
  padding: 50px;
}
.btnMenu{
  width: 100%;
  text-align: center;
}
.btnMenu button{
  margin-right: 10px;
}
.quatationSelection{
  margin-top: 50px;
}
.form-check{
  margin-bottom: 15px;
}
.login{
  max-width: 500px;
  margin: 0 auto;
}
@media only screen and (max-width: 768px) {
    .borderBottom{
        width: 40%;
        margin: 0 auto;
        margin-top: 50px;
        border: 1px solid black;
    }
    .discription{
        padding: 20px;
    }
}
</style>